import { createElementBlock as l, openBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function n(d, e) {
  return t(), l("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.885 2.483a1.317 1.317 0 0 1 1.853-.185l8.779 7.183a1.317 1.317 0 0 1 0 2.038l-8.78 7.183a1.317 1.317 0 0 1-1.667-2.038l7.534-6.164L5.07 4.336a1.317 1.317 0 0 1-.185-1.853",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const c = { render: n };
export {
  c as default,
  n as render
};
